import * as React from 'react';
import { Icon } from "@alifd/next";
import doLog from '../../common/log';
import IframeDialog from '../../common/dialog-iframe';
import Pop from './pop';

import './index.scss';

const { useState,useEffect } = React;

export default function Index ( props: { promoConfig: any; productId: any; i18n: any} ) {
  const { promoConfig,productId,i18n } = props;
  if ( !promoConfig || promoConfig === JSON.stringify( {} ) ) return null;
  const {
    DETAIL_BELT_ATOMOSPHERE,
    ICBU_DETAIL_BELT_ATOMOSPHERE_POPUP,
  } = JSON.parse( promoConfig );

  if ( !DETAIL_BELT_ATOMOSPHERE || DETAIL_BELT_ATOMOSPHERE.length === 0 ) return null;

  const { materialJSON } = DETAIL_BELT_ATOMOSPHERE[0];
 
  useEffect( () => {
    doLog( '/sc.details.commonLogs',`productId=${productId}&action=PromotionExp` );
  },[] )

  const [visible,setVisible] = useState( false );

  const renderTitle = () => {
      return <div className="promotion-title">
        {materialJSON?.styles?.logoImg && <img src={materialJSON.styles.logoImg} />}
        <span>{materialJSON?.texts?.title}</span>
      </div>
  }

  const renderList = () => {
    return DETAIL_BELT_ATOMOSPHERE.map( ( item: { materialJSON: { texts: { title: string | number | boolean | {} | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactNodeArray | React.ReactPortal; }; }; },index: React.Key ) => <div key={index} className='promotion-item'><img src="https://s.alicdn.com/@img/imgextra/i2/O1CN01lP9RGK28jOamCmna0_!!6000000007968-55-tps-4-4.svg" /> {item.materialJSON.texts.title}</div> )
  }

  const renderDialog = () => {
    return <IframeDialog iframeUrl={materialJSON?.texts?.benefitUrlPC} visible={visible} setVisible={setVisible} productId={productId} action="PromotionDialog" />
  }

  return (
    ICBU_DETAIL_BELT_ATOMOSPHERE_POPUP ? <Pop i18n={i18n} productId={productId} belt={ICBU_DETAIL_BELT_ATOMOSPHERE_POPUP} resource={DETAIL_BELT_ATOMOSPHERE}/> :
    <div className='detail-promotion' onClick={() => {
      doLog( '/sc.details.commonLogs',`productId=${productId}&action=PromotionClk` );
      setVisible( true )
    }
    } style={{
      backgroundImage: `url(${materialJSON?.styles?.backgroundImage})`
    }}>
      <div className='promotion-list'>
        {renderTitle()}
        {renderList()}
      </div>
      <Icon type="arrow-right" size="xs" />
      {renderDialog()}
    </div>
  )
}
